import { render } from "./CroppingsEditor.vue?vue&type=template&id=8a17447e&scoped=true&ts=true"
import script from "./CroppingsEditor.vue?vue&type=script&lang=ts"
export * from "./CroppingsEditor.vue?vue&type=script&lang=ts"

import "./CroppingsEditor.vue?vue&type=style&index=0&id=8a17447e&scoped=true&lang=scss"

import exportComponent from "/Users/otto/Code/projects/bubbly/doo/apps/builder-legacy/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-8a17447e"]])

export default __exports__